module.exports = __webpack_public_path__ + "media/images/subject_img/NATURAL SCIENCES-bf9f5af022b80c6e8bea3b0b4d74f52e.jpg";